<div id="loaderSpin">
  <section class="h-100">
    <header class="container h-100">
      <div class="d-flex align-items-center justify-content-center h-100">
        <div class="d-flex flex-column">
          <img src="../../../../assets/images/loader-big.svg">
          <p class="mt-2 mt-md-2">{{ modalText }}</p>
        </div>
      </div>
    </header>
  </section>
</div>